import { batch, computed, signal } from "@preact/signals-react"
import {
	acriss,
	acrissGroupBy,
	acrissGroups,
	analyzerDate,
	categories,
	currency,
	directSiteBrokerProvider,
	lengthRental,
	mainProvider,
	mainSite,
	offices,
	officesPickoff,
	providers,
	reports,
	searchID,
	sites,
	webSuppliers,
} from "@signals"
import { ACRISS_GROUP_BY, SEARCH_GROUP_BY } from "@constants"

export const oneWayData = signal({})
export const isOneWayLoading = signal(false)
export const oneWayPriceMode = signal('oneWay') // 'oneWay' | 'roundTrip'
export const oneWayExcelPayload = signal(null)

export const resetOneWayData = () => batch(() => {
	oneWayData.value = {}
	isOneWayLoading.value = false
	oneWayPriceMode.value = 'oneWay'
	oneWayExcelPayload.value = null
})

export const oneWayPayload = computed(() => ({
	reportType: 'one-way',
	reportExecutionID: reports.value,
	searchID: searchID.value,
	officePickupID: !searchID.value ? offices.value : null,
	// the rows are one dimension of the execution, so the table is one branch wide: a single,
	// mandatory dropoff office the selector preselects
	officeDropoffID: officesPickoff.value,
	siteID: sites.value,
	// which dimension the rows are: Direct Sites compares the webs, Broker compares the brands
	// inside one web. The backend cannot read it off the reference, which is optional.
	directSiteBrokerProvider: !!directSiteBrokerProvider.value,
	// narrows the table itself in Broker mode and the aggregation of each site row in Direct
	// Sites; the round trip baseline is matched on the same provider, so both sides of the fee
	// are filtered alike. The tier selector has no key of its own: it writes into `providers`.
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	// reference row: its fee is the baseline every other row is measured against, so it follows
	// the axis. The backend keeps it in the table even when the row filter would have left it
	// out, and ignores the one that does not belong to the current axis.
	siteMainID: directSiteBrokerProvider.value ? null : mainSite.value,
	providerMainID: directSiteBrokerProvider.value ? mainProvider.value : null,
	pickupDate: analyzerDate.value,
	lor: lengthRental.value,
	// the third level of the header groups by one of these three, and only the chosen one
	// travels: the other two would narrow the query without building any column
	acrissGroupBy: acrissGroupBy.value,
	acriss: acrissGroupBy.value === ACRISS_GROUP_BY.ACRISS ? acriss.value : null,
	categoryID: acrissGroupBy.value === ACRISS_GROUP_BY.CATEGORY ? categories.value : null,
	acrissGroupID: acrissGroupBy.value === ACRISS_GROUP_BY.ACRISS_GROUP ? acrissGroups.value : null,
	currency: currency.value,
	groupBy: SEARCH_GROUP_BY.DAY,
	isNewVersion: true,
}))